<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 20a8 8 0 01-8-8 7.91 7.91 0 012-5.28V8a1 1 0 002 0V4a1 1 0 00-1-1H3a1 1 0 000 2h1.87A9.91 9.91 0 002 12a10 10 0 0010 10 1 1 0 000-2zM21 19h-1.87A9.91 9.91 0 0022 12 10 10 0 0012 2a1 1 0 000 2 8 8 0 018 8 7.91 7.91 0 01-2 5.28V16a1 1 0 00-2 0v4a1 1 0 001 1h4a1 1 0 000-2z"/><path d="M12.5 12.59V10h-1v2.59a1.5 1.5 0 101 0z"/><path d="M14 8a2 2 0 00-4 0v3.78A2.94 2.94 0 009 14a3 3 0 006 0 2.94 2.94 0 00-1-2.22zm-2 8a2 2 0 01-1.2-3.59l.2-.15V8a1 1 0 012 0v4.26l.2.15A2 2 0 0112 16z"/></svg>